<template>
    <div>
        <div :id="labelId" class="font-bold text-xs text-slate-700 mb-2" data-test="sidebar-filter-label">
            {{ props.label }}
        </div>
        <vx-box color="info" class="p-4">
            <div
                ref="radioGroupRef"
                role="radiogroup"
                :aria-labelledby="labelId"
                class="flex flex-col gap-3"
                data-test="radio-group"
            >
                <div
                    v-for="(option, index) in props.options"
                    :key="option.value"
                    class="flex gap-2 items-center text-sm cursor-pointer"
                    @click.prevent="select(index, { focusVisible: false })"
                >
                    <vx-radio
                        role="radio"
                        :aria-checked="model === option.value"
                        :aria-labelledby="`${labelId}-${index}`"
                        :tabindex="index === tabStop ? 0 : -1"
                        :data-test="`${props.name}-${option.value}`"
                        :modelValue="model === option.value"
                        @keydown.space.prevent="model = option.value"
                        @keydown.enter.prevent="model = option.value"
                        @keydown.down.exact.prevent="move(index, 1)"
                        @keydown.right.exact.prevent="move(index, 1)"
                        @keydown.up.exact.prevent="move(index, -1)"
                        @keydown.left.exact.prevent="move(index, -1)"
                    ></vx-radio>
                    <span :id="`${labelId}-${index}`" aria-hidden="true">{{ option.label }}</span>
                </div>
            </div>
        </vx-box>
    </div>
</template>

<script lang="ts" setup>
import { VxBox, VxRadio } from '@voxie/frontend-components';
import { computed, useId, useTemplateRef } from 'vue';

const props = defineProps<{
    label: string;
    name: string;
    options: { label: string; value?: string }[];
}>();

const model = defineModel<string>();

const labelId = useId();
const radioGroupRef = useTemplateRef<HTMLElement>('radioGroupRef');

const tabStop = computed(() => {
    const checked = props.options.findIndex((option) => option.value === model.value);

    return -1 === checked ? 0 : checked;
});

const select = (index: number, options?: FocusOptions) => {
    model.value = props.options[index]?.value;
    radioGroupRef.value?.querySelectorAll<HTMLElement>('[role="radio"]')[index]?.focus(options);
};

const move = (index: number, step: number) => {
    select((index + step + props.options.length) % props.options.length);
};
</script>
